import { createStyles, makeStyles } from '@mui/styles';

export default makeStyles(theme => createStyles({
  AppLayoutContainer: {
    height: "100%",
    width: "100%"
  },
}));
